<template>
  <ui-button class="centerText" v-on:click.native="click" :to="to" :backgroundColor="bgColor" color="#FFFFFF">
      <div slot="title">{{ $t(title) }}</div>
  </ui-button>

</template>

<script>
import UiButton from '../UiButton.vue';

export default {
  name: 'button-action',
  props:{
    title:{default:"no title prop set."},
    to:{default:""},
    active:{
      type:Boolean,
      default:true
    },
  },
  data:function(){
    return {
    }
  },
  computed:{
    bgColor:function(){
      if(this.active){
        return "#50C0DB";
      }else{
        return "#707070";
      }
    }
  },
  methods:{
    click(event){
      if(!this.active){
        // prevent button events on further bubble
        event.stopImmediatePropagation();
      }
    }
  },
  mounted:function(){
    
  },
  components:{
    UiButton
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.centerText{
  text-align:center;
}
</style>
